import type { StatusTone } from '../../framework/components/app';

export function userRoleTone(role?: string | null): StatusTone {
    const name = (role ?? '').toLowerCase();
    if (name.includes('owner')) return 'success';
    if (name.includes('admin')) return 'info';
    return 'neutral';
}

export function userStatusTone(status?: string | null): StatusTone {
    const name = (status ?? '').toLowerCase();
    if (name.includes('active')) return 'success';
    if (name.includes('inactive') || name.includes('suspend') || name.includes('disabled') || name.includes('blocked')) {
        return 'danger';
    }
    if (name.includes('pending') || name.includes('invite')) return 'warn';
    return 'neutral';
}

export function invoiceStatusTone(status?: string | null): StatusTone {
    const name = (status ?? '').toLowerCase();
    if (name === 'paid') return 'success';
    if (name === 'overdue') return 'danger';
    if (name === 'sent') return 'info';
    if (name === 'draft') return 'neutral';
    return 'warn';
}

export function briefStatusTone(status?: string | null): { tone: StatusTone; color: string } {
    const normalized = (status ?? '').toLowerCase();
    if (normalized === 'active') {
        return { tone: 'neutral', color: 'var(--grey-secondary)' };
    }
    if (normalized.includes('progress') || normalized === 'idle') {
        return { tone: 'info', color: 'var(--status-info)' };
    }
    if (normalized.includes('complete') || normalized.includes('valid') || normalized.includes('strong')) {
        return { tone: 'success', color: 'var(--status-success)' };
    }
    if (normalized.includes('fail') || normalized.includes('reject') || normalized.includes('weak')) {
        return { tone: 'danger', color: 'var(--status-danger)' };
    }
    if (normalized === 'executed') {
        return { tone: 'neutral', color: 'var(--accent-purple)' };
    }
    return { tone: 'neutral', color: 'var(--grey-secondary)' };
}
